import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useAppTranslation } from "@/hooks/use-app-translation";
import { organizationQueryOptions } from "@/services/organization";

export const Route = createFileRoute(
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/home",
)({
	component: RouteComponent,
});

function RouteComponent() {
	const { t } = useAppTranslation();
	const { orgId } = Route.useParams();

	const organizationQuery = useQuery({
		...organizationQueryOptions.detail(orgId),
		select: (data) => data?.name,
	});

	const organizationName = organizationQuery.data || "";

	return (
		<div className="p-8 space-y-8">
			{/* Page Header */}
			<div>
				<h1 className="text-3xl font-bold text-gray-900">
					{t("org-admin./.title")}
				</h1>
				<p className="mt-2 text-gray-600">
					{t("org-admin.home.description", { organizationName })}
				</p>
			</div>
		</div>
	);
}
